//
//
//
//
//
//
//

import { useUser } from '@bee-hole/coms';
import { useRouter } from '@nuxtjs/composition-api';

export default {
  name: 'ProfileUpdateForm',
  setup() {
    const router = useRouter();
    const { user, logout, error } = useUser();

    function handleLogout() {
      logout();
      if (!error.value.logout) {
        router.push('/');
      }
    }

    return { user, handleLogout };
  }
};
